<template>
  <v-dialog
    persistent
    width="1000"
    v-model="visible"
  >
    <v-card>
      <v-container>
        <v-btn icon text small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-divider />

        <h6 class="ml-1 font-weight-bold">Datos del Beneficiario</h6>
        <v-divider />

        <v-row>
          <v-col cols="8">
            <v-text-field
              label="RUT"
              v-model="detalle.rut"
              filled
              dense
              :error-messages="fieldErrors.rut || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="DV"
              v-model="detalle.dv"
              filled
              dense
              maxlength="1"
              @input="detalle.dv = detalle.dv ? String(detalle.dv).toUpperCase() : ''"
              :error-messages="fieldErrors.dv || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Apellido Paterno"
              v-model="detalle.apellidopaterno"
              filled
              dense
              :error-messages="fieldErrors.apellidopaterno || []"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Apellido Materno"
              v-model="detalle.apellidomaterno"
              filled
              dense
              :error-messages="fieldErrors.apellidomaterno || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Nombre"
              v-model="detalle.nombre"
              filled
              dense
              :error-messages="fieldErrors.nombre || []"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Correo"
              v-model="detalle.correo"
              filled
              dense
              :error-messages="fieldErrors.correo || []"
            />
          </v-col>
        </v-row>

        <h6 class="ml-1 font-weight-bold">Dirección Beneficiario</h6>
        <v-divider />

        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Calle"
              v-model="detalle.calle"
              filled
              dense
              :error-messages="fieldErrors.calle || []"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Número"
              v-model="detalle.dirnumero"
              filled
              dense
              :error-messages="fieldErrors.dirnumero || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-autocomplete
              label="Código Comuna"
              v-model="detalle.codigocomuna"
              :items="comunas"
              filled
              dense
              :error-messages="fieldErrors.codigocomuna || []"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              label="Tipo Calle"
              v-model="detalle.tipocalle"
              :items="tipoDeCalle"
              filled
              dense
              :error-messages="fieldErrors.tipocalle || []"
            />
          </v-col>
        </v-row>

        <h6 class="ml-1 font-weight-bold">Datos de Pago</h6>
        <v-divider />

        <v-row>
          <v-col cols="12">
            <v-select
              label="Banco (BIF)"
              v-model="detalle.bancopagosbif"
              :items="tipoDeBancos"
              item-value="id"
              item-text="name"
              filled
              dense
              :error-messages="fieldErrors.bancopagosbif || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-select
              label="Tipo Cuenta Pago"
              v-model="detalle.tipocuentapago"
              :items="tipoDeCuentaPagos"
              filled
              dense
              :error-messages="fieldErrors.tipocuentapago || []"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Número Cuenta Pago"
              v-model="detalle.numerocuentapago"
              filled
              dense
              type="text"
              @input="detalle.numerocuentapago = detalle.numerocuentapago ? detalle.numerocuentapago.replace(/[^0-9]/g, '') : ''"
              :error-messages="fieldErrors.numerocuentapago || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8">
            <v-text-field
              label="Monto Pago"
              v-model="detalle.montopago"
              filled
              dense
              readonly
              disabled
              :error-messages="fieldErrors.montopago || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Moneda Pago"
              v-model="detalle.monedapago"
              filled
              dense
              readonly
              disabled
              :error-messages="fieldErrors.monedapago || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Nombre Elección"
              v-model="detalle.nombreeleccion"
              filled
              dense
              :error-messages="fieldErrors.nombreeleccion || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Fecha Elección"
              v-model="detalle.fechaeleccion"
              type="date"
              filled
              dense
              :error-messages="fieldErrors.fechaeleccion || []"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              label="Concepto de pago"
              v-model="detalle.conceptopago"
              :items="conceptos"
              item-value="id"
              item-text="name"
              filled
              dense
              :error-messages="fieldErrors.conceptopago || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Código Mesa"
              v-model="detalle.codigomesa"
              filled
              dense
              :error-messages="fieldErrors.codigomesa || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Código Registro"
              v-model="detalle.codigoregistro"
              filled
              dense
              :error-messages="fieldErrors.codigoregistro || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="DV Código Registro"
              v-model="detalle.dvfolio"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.dvfolio || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Nombre Comuna"
              v-model="detalle.nombrecomuna"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.nombrecomuna || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Número Región"
              v-model="detalle.numeroregion"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.numeroregion || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Tipo Elección"
              v-model="detalle.tipoeleccion"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.tipoeleccion || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Fecha Capacitación"
              v-model="detalle.fechacapacitacion"
              type="datetime-local"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.fechacapacitacion || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Identificación Local"
              v-model="detalle.identificacionlocal"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.identificacionlocal || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Código Circunscripción"
              v-model="detalle.codigocircunscripcion"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.codigocircunscripcion || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Circunscripción Electoral"
              v-model="detalle.circunscripcionelectoral"
              maxlength="255"
              filled
              dense
              :error-messages="fieldErrors.circunscripcionelectoral || []"
            />
          </v-col>
          <v-col cols="4">
            <v-select
              label="Medio de Pago"
              v-model="detalle.mediopago"
              :items="medioPagoOptions"
              filled
              dense
              :error-messages="fieldErrors.mediopago || []"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="URL Documento Original"
              v-model="detalle.urldocumento"
              readonly
              disabled
              filled
              dense
              :error-messages="fieldErrors.urldocumento || []"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Archivo De Carga"
              v-model="detalle.archivo"
              readonly
              disabled
              filled
              dense
              :error-messages="fieldErrors.archivo || []"
            />
          </v-col>
        </v-row>

        <h6 class="ml-1 font-weight-bold">Estado del Pago</h6>
        <v-divider />

        <v-row>
          <v-col cols="4">
            <v-text-field
              label="Estado"
              v-model="detalle.estado"
              readonly
              filled
              dense
            />
          </v-col>

          <v-col cols="8">
            <v-textarea
              label="Resp. Medio Pago"
              :value="JSON.stringify(detalle.mediopagoresp, null, 2)"
              readonly
              filled
              auto-grow
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="detalle.error"
              color="error"
              icon="$error"
              title="Errores"
            >
              <pre class="mb-0" style="white-space: pre-line;">{{ erroresComoTexto }}</pre>
            </v-alert>
          </v-col>
        </v-row>

        <v-divider />

        <div class="mt-5 d-flex justify-end">
          <v-btn
            color="success"
            class="mr-2"
            @click="saveChanges"
            v-if="showButtons(6) || showButtons(9)"
          >
            Guardar cambios
          </v-btn>
          <v-btn color="primary" @click="closeDialog">
            Cerrar
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { PagoVocalesService } from "../../util/Api/PagoVocales/calls";
import { Loading } from "element-ui";
import Swal from "sweetalert2";
import comunas from "../../util/comunas";

export default {
  name: "ModalDetallePagoVocal",

  model: {
    prop: "visible",
    event: "update:visible",
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    pagoId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      detalle: {},
      fieldErrors: {},
      loadingInstance: null,
      comunas: [],
      tipoDeCalle: ["CALLE", "AVENIDA", "PASAJE"],
      tipoDeCuentaPagos: ["CUENTA_CORRIENTE", "CUENTA_AHORRO", "CUENTA_VISTA"],
      medioPagoOptions: ["DEPOSITO", "PAGOPORCAJA"],
      conceptos: [
        {
          id: "SERVEL_PAGO_VOCAL",
          name: "PAGO A VOCAL",
        },
        {
          id: "SERVEL_PAGO_CAPACITADO",
          name: "PAGO POR CAPACITACION",
        },
        {
          id: "SERVEL_PAGO_ESCRUTADOR",
          name: "PAGO POR ESCRUTADOR",
        },
      ],
      tipoDeBancos: [
        { id: 1, name: "Banco de Chile" },
        { id: 9, name: "Banco Internacional" },
        { id: 14, name: "Scotiabank" },
        { id: 16, name: "Banco de crédito e Inversiones" },
        { id: 28, name: "Banco BICE" },
        { id: 31, name: "HSBC Bank Chile" },
        { id: 37, name: "Banco Santander Chile" },
        { id: 39, name: "Itaú CorpBanca" },
        { id: 49, name: "Banco Security" },
        { id: 51, name: "Banco Falabella" },
        { id: 53, name: "Banco Ripley" },
        { id: 54, name: "Rabobank Chile" },
        { id: 55, name: "Banco Consorcio" },
        { id: 56, name: "Banco Penta" },
        { id: 504, name: "Banco Bilbao Vizcaya Argentaria Chile (BBVA)" },
        { id: 59, name: "Banco BTG Pactual Chile" },
        { id: 12, name: "Banco Estado" },
        { id: 672, name: "Coopeuch" },
        { id: 875, name: "Mercadopago" },
      ],
    };
  },

  watch: {
    combinedProps: {
      handler({ visible, pagoId }) {
        if (visible && pagoId !== null) {
          this.loadDetalle();
        }
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    ...mapGetters(["getPerfil"]),

    combinedProps() {
      return {
        visible: this.visible,
        pagoId: this.pagoId,
      };
    },

    erroresComoTexto() {
      const err = this.detalle.error;
      if (!err) return "";

      if (typeof err.message === "string" && !err.validador && !err.sanitizacion && !err.padron) {
        return err.message;
      }

      const lineas = [];

      if (err.validador && typeof err.validador === "object") {
        Object.entries(err.validador).forEach(([campo, info]) => {
          const msg = info && info.message ? info.message : JSON.stringify(info);
          lineas.push(`Validación - ${campo}: ${msg}`);
        });
      }

      if (err.sanitizacion && typeof err.sanitizacion === "object") {
        Object.entries(err.sanitizacion).forEach(([campo, info]) => {
          const motivo = info && info.motivo ? info.motivo : "";
          const original = info && info.original !== undefined ? ` (valor original: ${info.original})` : "";
          lineas.push(`Sanitización - ${campo}: ${motivo}${original}`);
        });
      }

      if (err.padron) {
        if (err.padron.motivo === "padron_no_configurado") {
          lineas.push(`Padrón - No hay padrón configurado para la elección ${err.padron.eleccion}`);
        } else if (err.padron.motivo === "rut_no_en_padron") {
          lineas.push(`Padrón - El RUT no existe en el padrón ${err.padron.tabla}`);
        } else {
          lineas.push(`Padrón - ${JSON.stringify(err.padron)}`);
        }
      }

      if (!lineas.length) {
        if (typeof err === "string") return err;
        if (typeof err.message === "string") return err.message;
        return JSON.stringify(err, null, 2);
      }

      return lineas.join("\n");
    },
  },

  mounted() {
    this.comunas = comunas.comunas;
  },

  methods: {
    showButtons(accesoId) {
      if (!this.getPerfil) {
        return false;
      }

      return (
        this.getPerfil.accesos &&
        Array.isArray(this.getPerfil.accesos) &&
        this.getPerfil.accesos.some((acceso) => acceso.id === accesoId)
      );
    },

    addError(errors, field, message) {
      if (!errors[field]) {
        errors[field] = [];
      }
      errors[field].push(message);
    },

    validateDetalle() {
      const d = this.detalle || {};
      const errors = {};

      const requiredString = (field, label, max = 255) => {
        const v = d[field];
        if (v === undefined || v === null || String(v).trim() === "") {
          this.addError(errors, field, `${label} es requerido`);
          return;
        }
        if (String(v).length > max) {
          this.addError(errors, field, `${label} debe tener como máximo ${max} caracteres`);
        }
      };

      const optionalMax = (field, label, max = 255) => {
        const v = d[field];
        if (v !== undefined && v !== null && String(v).length > max) {
          this.addError(errors, field, `${label} debe tener como máximo ${max} caracteres`);
        }
      };

      requiredString("conceptopago", "Concepto de pago");
      requiredString("nombreeleccion", "Nombre elección");

      const fe = d.fechaeleccion;
      if (!fe || !/^\d{4}-\d{2}-\d{2}$/.test(String(fe))) {
        this.addError(errors, "fechaeleccion", "Fecha elección es requerida y debe tener formato YYYY-MM-DD");
      }

      if (d.rut === undefined || d.rut === null || String(d.rut).trim() === "") {
        this.addError(errors, "rut", "RUT es requerido");
      } else if (!/^\d+$/.test(String(d.rut))) {
        this.addError(errors, "rut", "RUT debe ser entero");
      }

      if (d.dv === undefined || d.dv === null || String(d.dv).trim() === "") {
        this.addError(errors, "dv", "DV es requerido");
      } else if (String(d.dv).length !== 1) {
        this.addError(errors, "dv", "DV debe tener exactamente 1 carácter");
      }

      requiredString("apellidopaterno", "Apellido paterno");
      requiredString("apellidomaterno", "Apellido materno");
      requiredString("nombre", "Nombre");

      optionalMax("tipopersona", "Tipo persona", 50);

      if (d.correo !== undefined && d.correo !== null && String(d.correo).trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(String(d.correo))) {
          this.addError(errors, "correo", "Correo no es válido");
        }
        optionalMax("correo", "Correo");
      }

      optionalMax("codigocomuna", "Código comuna");
      optionalMax("calle", "Calle");
      optionalMax("tipocalle", "Tipo calle");
      optionalMax("dirnumero", "Número dirección");

      if (d.bancopagosbif === undefined || d.bancopagosbif === null || String(d.bancopagosbif).trim() === "") {
        this.addError(errors, "bancopagosbif", "Banco es requerido");
      } else if (!Number.isInteger(Number(d.bancopagosbif))) {
        this.addError(errors, "bancopagosbif", "Banco debe ser numérico entero");
      }

      requiredString("tipocuentapago", "Tipo cuenta pago");

      if (d.numerocuentapago === undefined || d.numerocuentapago === null || String(d.numerocuentapago).trim() === "") {
        this.addError(errors, "numerocuentapago", "Número cuenta pago es requerido");
      } else if (!/^[0-9]+$/.test(String(d.numerocuentapago))) {
        this.addError(errors, "numerocuentapago", "Número cuenta pago debe contener solo números");
      } else if (String(d.numerocuentapago).length > 15) {
        this.addError(errors, "numerocuentapago", "Número cuenta pago debe tener máximo 15 dígitos");
      }

      if (d.montopago === undefined || d.montopago === null || String(d.montopago).trim() === "") {
        this.addError(errors, "montopago", "Monto pago es requerido");
      } else if (isNaN(Number(d.montopago))) {
        this.addError(errors, "montopago", "Monto pago debe ser numérico");
      }

      requiredString("monedapago", "Moneda pago");

      if (d.mediopago !== undefined && d.mediopago !== null && String(d.mediopago).trim() !== "") {
        if (!["DEPOSITO", "PAGOPORCAJA"].includes(String(d.mediopago))) {
          this.addError(errors, "mediopago", "Medio pago contiene un valor no permitido");
        }
        optionalMax("mediopago", "Medio pago");
      }

      optionalMax("codigoregistro", "Código registro");
      optionalMax("codigomesa", "Código mesa");
      optionalMax("urldocumento", "URL documento");
      optionalMax("archivo", "Archivo");
      optionalMax("dvfolio", "DV código registro");
      optionalMax("nombrecomuna", "Nombre comuna");
      optionalMax("numeroregion", "Número región");
      optionalMax("tipoeleccion", "Tipo elección");
      optionalMax("fechacapacitacion", "Fecha capacitación");
      optionalMax("identificacionlocal", "Identificación local");
      optionalMax("codigocircunscripcion", "Código circunscripción");
      optionalMax("circunscripcionelectoral", "Circunscripción electoral");
      optionalMax("idinstitucion", "Id institución", 50);
      optionalMax("numeroordenpago", "Número orden de pago");

      return errors;
    },

    async loadDetalle() {
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "Cargando...",
        background: "rgba(0, 0, 0, 0.8)",
      });

      this.fieldErrors = {};

      try {
        const params = {
          id: this.pagoId,
        };

        this.detalle = await PagoVocalesService.getById(params);

        if (this.detalle && this.detalle.fechaeleccion) {
          this.detalle.fechaeleccion = this.normalizeDateOnly(this.detalle.fechaeleccion);
        }

        if (this.detalle && this.detalle.fechacapacitacion) {
          this.detalle.fechacapacitacion = this.normalizeDateTimeInput(this.detalle.fechacapacitacion);
        }
      } catch (error) {
        console.error("Error cargando detalle de pago:", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los pagos: ${error}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
      }
    },

    normalizeDateOnly(value) {
      if (!value) return value;

      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return value;
      }

      const d = new Date(value);
      if (!isNaN(d)) {
        return d.toISOString().slice(0, 10);
      }

      return value;
    },

    normalizeDateTime(value) {
      if (!value) return value;

      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
        return value;
      }

      const d = new Date(value);
      if (!isNaN(d)) {
        return d.toISOString();
      }

      return value;
    },

    normalizeDateTimeInput(value) {
      if (!value) return value;

      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value)) {
        return value;
      }

      const d = new Date(value);
      if (!isNaN(d)) {
        return d.toISOString().slice(0, 16);
      }

      return value;
    },

    async saveChanges() {
      this.fieldErrors = {};

      const validationErrors = this.validateDetalle();
      if (Object.keys(validationErrors).length) {
        this.fieldErrors = validationErrors;
        return;
      }

      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "Cargando...",
        background: "rgba(0, 0, 0, 0.8)",
      });

      let success = false;

      try {
        const payload = {
          ...this.detalle,
          rut: this.detalle.rut !== null && this.detalle.rut !== undefined && String(this.detalle.rut).trim() !== ""
            ? Number(this.detalle.rut)
            : null,
          bancopagosbif: this.detalle.bancopagosbif !== null && this.detalle.bancopagosbif !== undefined && String(this.detalle.bancopagosbif).trim() !== ""
            ? Number(this.detalle.bancopagosbif)
            : null,
          numerocuentapago: this.detalle.numerocuentapago !== null && this.detalle.numerocuentapago !== undefined && String(this.detalle.numerocuentapago).trim() !== ""
            ? String(this.detalle.numerocuentapago).trim()
            : null,
          montopago: this.detalle.montopago !== null && this.detalle.montopago !== undefined && String(this.detalle.montopago).trim() !== ""
            ? Number(this.detalle.montopago)
            : null,
          dv: this.detalle.dv ? String(this.detalle.dv).trim().toUpperCase() : null,
          fechaeleccion: this.normalizeDateOnly(this.detalle.fechaeleccion),
          fechacapacitacion: this.detalle.fechacapacitacion
            ? this.normalizeDateTime(this.detalle.fechacapacitacion)
            : null,
          dvcodigoregistro: this.detalle.dvfolio,
          idusuario: this.getPerfil.id,
        };

        Object.keys(payload).forEach((key) => {
          if (typeof payload[key] === "string") {
            payload[key] = payload[key].trim();
            if (payload[key] === "") {
              payload[key] = null;
            }
          }
        });

        const response = await PagoVocalesService.send(payload);

        if (response.statusCode !== 201) {
          throw response.msg || response;
        }

        Swal.fire({
          type: "success",
          html: "Datos actualizados",
        });

        success = true;
      } catch (error) {
        Swal.fire({
          type: "error",
          html: `Error al editar el pago: ${typeof error === "string" ? error : JSON.stringify(error)}`,
        });
      } finally {
        if (this.loadingInstance) this.loadingInstance.close();
        if (success) {
          this.closeDialog();
        }
      }
    },

    closeDialog() {
      this.$emit("update:visible", false);
      this.detalle = {};
      this.fieldErrors = {};
    },
  },
};
</script>

<style scoped></style>